export default {
    chart: {
        height: 216
    },
    title: {
        text: 'Recent Activity'
    },
    legend: {
        enabled: false
    }
};



// WEBPACK FOOTER //
// ./app/services/charting/presets/preview.js